import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SelectButtonComponent } from './selectButton.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: SelectButtonComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class SelectRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/view/selectButton/select-routing.module.ts